export default {
    LOAD_BANK_ACCOUNT(state, bank_account) {
        state.items = bank_account
    }
}